import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=b5acfb42"
import script from "./AddArea.vue?vue&type=script&lang=js"
export * from "./AddArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports